import { render, staticRenderFns } from "./CreateANewLanguageManager.vue?vue&type=template&id=288ec0b5"
import script from "./CreateANewLanguageManager.vue?vue&type=script&lang=js"
export * from "./CreateANewLanguageManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports